import { render, staticRenderFns } from "./CourseFormPreview.vue?vue&type=template&id=37c4b000"
import script from "./CourseFormPreview.vue?vue&type=script&lang=js"
export * from "./CourseFormPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports